<div class="main-content-wrapper authentication-page-section">
    <form #form="ngForm" [formGroup]="reportFilterForm">
        <div class="row mt-2">
            <div class="col-6 col-xl-4">
                <div class="form-group mat-form-field-width">
                    <mat-form-field appearance="outline">
                        <mat-select placeholder="Select Device ID" [compareWith]="utils.idComparer"
                            formControlName="deviceId">
                            @for(list of deviceIdList; track list) {
                                <mat-option [value]="list">
                                    {{list}}
                                </mat-option>
                            }
                        </mat-select>
                    </mat-form-field>
                </div>
            </div>
            @if(hasParameterDropdown) {
                <div class="col-6 col-xl-4">
                    <div class="form-group mat-form-field-width">
                        <mat-form-field appearance="outline">
                            <mat-select placeholder="Select Parameter" [compareWith]="utils.idComparer"
                                formControlName="parameterId">
                                @for(list of parameterIdList; track list) {
                                    <mat-option [value]="list">
                                        {{list}}
                                    </mat-option>
                                }
                            </mat-select>
                        </mat-form-field>
                    </div>
                </div>
            }
            <div class="col-6 col-xl-4">
                <div class="form-group mat-form-field-width">
                    <mat-form-field appearance="outline">
                        <mat-select placeholder="SELECT FIELD" [compareWith]="utils.idComparer"
                            formControlName="selectColumn" multiple>
                            @for(list of columnFieldList; track list) {
                                <mat-option  class="text-capitalize" [value]="list">
                                    {{list}}
                                </mat-option>
                            }
                        </mat-select>
                    </mat-form-field>
                </div>
            </div>
            <div class="col-6 col-xl-4">
                <div class="form-group mat-form-field-width">
                    <mat-form-field appearance="outline">
                        <mat-datetimepicker-toggle [for]="datetimePickerStart" matSuffix></mat-datetimepicker-toggle>
                        <mat-datetimepicker #datetimePickerStart type="datetime" openOnFocus:true timeInterval:5
                            mode="portrait"></mat-datetimepicker>
                        <input matInput formControlName="startDate" [matDatetimepicker]="datetimePickerStart"
                            placeholder="Choose a start date" autocomplete="false"
                            />
                    </mat-form-field>
                </div>
            </div>
            <div class="col-6 col-xl-4">
                <div class="form-group mat-form-field-width">
                    <mat-form-field appearance="outline">
                        <mat-datetimepicker-toggle [for]="datetimePicker" matSuffix></mat-datetimepicker-toggle>
                        <mat-datetimepicker #datetimePicker type="datetime" openOnFocus:true timeInterval:5
                            mode="portrait"></mat-datetimepicker>
                        <input matInput formControlName="endDate" [matDatetimepicker]="datetimePicker"
                            placeholder="Choose a end date" autocomplete="false" />
                    </mat-form-field>
                </div>
            </div>
            @if (!hasParameterDropdown) {
                <div class="col-6 col-xl-4">
                    <div class="form-group mat-form-field-width">
                        <mat-form-field appearance="outline">
                            <mat-select formControlName="timeInterval" [compareWith]="utils.idComparer" 
                            placeholder="Select Interval">
                                @for (intervalTime of intervals; track intervalTime) {
                                <mat-option [value]="intervalTime">
                                    {{intervalTime.value}}
                                </mat-option>
                                }
                            </mat-select>
                        </mat-form-field>
                    </div>
                </div>
            }
        </div>
    </form>
    <div class="row text-end">
        <div class="col-12">
            @if (zerocalibrationBtn) {
                <button class="w-30 me-2" type="submit" mat-flat-button color="primary">
                    Zero Calibration
                </button>
            }
            <button class="w-30" type="submit" mat-flat-button color="primary" (click)="onDeviceIdChange()">
                Search
            </button>
        </div>
    </div>
</div>